import { useEffect, useRef } from 'react';

let turnstileScriptPromise;

function loadTurnstileScript() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (turnstileScriptPromise) return turnstileScriptPromise;

  turnstileScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.addEventListener('load', () => resolve(window.turnstile), { once: true });
    script.addEventListener('error', () => reject(new Error('Turnstile failed to load.')), { once: true });
    document.head.appendChild(script);
  });

  return turnstileScriptPromise;
}

// Turnstile uses explicit rendering because the contact form belongs to a SPA.
export function TurnstileWidget({ siteKey, onTokenChange, onError }) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  useEffect(() => {
    if (!siteKey) return undefined;
    let cancelled = false;

    loadTurnstileScript()
      .then((turnstile) => {
        if (cancelled || !turnstile || !containerRef.current) return;

        widgetIdRef.current = turnstile.render(containerRef.current, {
          sitekey: siteKey,
          action: 'contact',
          theme: 'light',
          size: 'flexible',
          callback: onTokenChange,
          'expired-callback': () => onTokenChange(''),
          'timeout-callback': () => onTokenChange(''),
          'error-callback': () => {
            onTokenChange('');
            onError();
            return true;
          },
        });
      })
      .catch(onError);

    return () => {
      cancelled = true;
      if (widgetIdRef.current !== null && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current);
      }
    };
  }, [onError, onTokenChange, siteKey]);

  if (!siteKey) return null;
  return <div ref={containerRef} className="turnstile-widget" />;
}
